import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const FilterSection = styled.div`
  position: relative;
  padding: 0px 30px 0px 50px;
  background: #eaeaee;
  ${props =>
    props.isDocumentSection &&
    `
  padding: 20px 30px 20px 50px;
  margin-top: 5px;
  background: #d9d9e0;
  `}
  @media (max-width: ${breakpoints.bpPhonePx}) {
    padding: 0px 15px 0px 15px;
    ${props =>
      props.isDocumentSection &&
      `
    padding: 15px;
  `}
  }
`

export default FilterSection
